export enum TypeDiffusionEnum {
  PHR,
  PQR,
  PQL,
  SPEL,
  AUCUN,
  PRESSE_SPE = "Presse specialisée",
}
